import type { AlertOptions } from './alert-controller';

/**
 * What makes two alerts "the same question": everything the person sees in it. Every alert
 * shares one component and one target, so without this key any alert open on screen would
 * answer any other alert's caller (df-93a444035272). With it, an identical repeat (a double
 * tap, one guard firing twice) still shares the alert on screen, and a different question
 * waits its turn. A field left out here lets two different alerts share one answer, so a new
 * visible field on AlertOptions belongs in this list too.
 * Call it after validateButtonRoles, which may reorder the buttons.
 */
export function alertDedupeKey<returnType>(opts: AlertOptions<returnType>): string {
  return JSON.stringify([
    opts.title ?? null,
    opts.subTitle ?? null,
    opts.message ?? null,
    opts.messageMarkdown ?? null,
    (opts.inputs ?? []).map(input => [
      input.type ?? null,
      input.name ?? null,
      input.label ?? null,
      input.description ?? null,
      input.placeholder ?? null,
      input.value ?? null,
      input.checked ?? null,
      input.disabled ?? null,
      input.min ?? null,
      input.max ?? null,
      (input.selectOptions ?? []).map(option => [option.label ?? null, option.value ?? null]),
    ]),
    (opts.buttons ?? []).map(button => [button.text ?? null, button.role ?? null, button.badge ?? null]),
  ]);
}
